<template>
    <v-card flat v-bind="{ loading }">
        <h5 class="page-text--lg mb-8 mb-lg-16">
            메모하기
        </h5>
        <vertical-form-table v-model="form" v-bind="{ items }">
            <template #메모내용>
                <v-textarea v-model="form.content" v-bind="attrs_input" @input="emit" />
            </template>
        </vertical-form-table>
        <v-layout justify-center class="mt-20 mt-lg-40">
            <v-btn v-bind="{ loading }" color="primary" class="min-w-100px min-w-140px" @click="post">저장</v-btn>
        </v-layout>
    </v-card>
</template>

<script>
import { attrs_input, initMemo } from "@/assets/variables";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const items = [
    {
        key: "content",
        term: "메모내용",
    },
];

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        value: { type: Object, default: () => ({}) }, // memo
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initMemo(),

        items,
        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.form = { ...initMemo(), ...this.value };
        },
        emit() {
            this.$emit("input", this.form);
        },
        post() {
            this.$emit("post");
        },
    },
};
</script>

<style>
</style>